import { render, staticRenderFns } from "./SlotCalendar.vue?vue&type=template&id=45503e97&scoped=true"
import script from "./SlotCalendar.vue?vue&type=script&lang=js"
export * from "./SlotCalendar.vue?vue&type=script&lang=js"
import style0 from "./SlotCalendar.vue?vue&type=style&index=0&id=45503e97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45503e97",
  null
  
)

export default component.exports